<template>
    <div class="schedule_top_filter">
        <!-- 버튼에 off 클래스 적용 시 필터 해제 상태 -->
        <div class="schedule_code_wrap">
            <button class="btn btn_s btn_white color_filter" :class="{ off: !isSelectedAll }" @click="action_SelectAll">
                {{ $t('common.all') }}
            </button>
            <CodeItem v-for="(code, index) in codes" :key="index" :code="code" />
        </div>
        <label class="check_wrap" v-if="!isEditMode">
            <input type="checkbox" v-model="showCustomTimeCode" />
            <span class="checkmark"></span>
            {{ $t('work_schedule.top.label_show_custom_times') }}
        </label>
        <label class="check_wrap" v-if="!isEditMode">
            <input type="checkbox" v-model="showBasicEmployee" />
            <span class="checkmark"></span>
            {{ $t('work_schedule.top.label_show_default_worker') }}
        </label>
        <div class="mgl_auto">
            <button class="btn btn_s btn_white" @click="action_ShowWorkCodeSetting">{{ $t('work_schedule.top.label_work_code_settings') }}</button>
            <button class="btn btn_s btn_white" v-if="!isEditMode" @click="action_ShowWorkerSetting">{{ $t('work_schedule.top.label_operation_settings') }}</button>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { workerState, setShowCustomTimeCode, setShowBasicEmployee, setWorkCodes, workCodesUpdate, showWorkerSetting, showWorkCodeSetting } from '../../../worker-state'

import CodeItem from './CodeItem.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2WorkCodeFindQueryOptions } from '@/composables/queries/v2workcode/use-v2-workcode-find-query'

// const moment = require('@/util/MPMoment')

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: { CodeItem },
    data() {
        return {
            worker: workerState,
        }
    },
    watch: {
        // TODO: data push notification handle?
        selectedDate: {
            deep: true,
            handler: function () {
                // this.loadWorkCodes()
            }
        },
        dateArray: {
            deep: true,
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                this.loadWorkCodes()
            }
        },
        'worker.needUpdateCodes': {
            handler: function (newValue) {
                if (newValue == true) {
                    this.$nextTick(() => {
                        this.worker.needUpdateCodes = false
                        this.loadWorkCodes()
                    })
                }
            }
        }
    },
    computed: {
        // v-model 로 쓰기가 일어나므로 set 은 vuex 영속화를 거치는 함수를 태운다
        showCustomTimeCode: {
            get() { return this.worker.isShowCustomTimeCode },
            set(newValue) { setShowCustomTimeCode(newValue) }
        },
        showBasicEmployee: {
            get() { return this.worker.isShowBasicEmployee },
            set(newValue) { setShowBasicEmployee(newValue) }
        },
        codes: function () {
            return this.worker.workCodes
        },
        isEditMode: function () {
            return this.worker.isModifyMode
        },
        isSelectedAll: function () {
            let unSelected = this.codes.find((c) => c.isSelected == false)
            if (unSelected == undefined) {
                return true
            }
            return false
        },
        isShowCustomTimeCode: function () {
            return this.worker.isShowCustomTimeCode
        },
        isShowBasicEmployee: function () {
            return this.worker.isShowBasicEmployee
        },
        selectedDate: function () {
            return this.worker.selectedDate
        },
        dateArray: function () {
            return this.worker.dateArray
        }
    },
    methods: {
        // MARK: - Actions
        action_ShowWorkerSetting() {
            showWorkerSetting()
        },
        action_ShowWorkCodeSetting() {
            showWorkCodeSetting()
        },

        action_SelectAll() {
            let codes = deepCopy(this.codes)
            let isSelected = true
            if (this.isSelectedAll == true) {
                isSelected = false
            }
            for (let i = 0; i < codes.length; i++) {
                codes[i].isSelected = isSelected
            }
            this.worker.oldWorkCodeRecords = deepCopy(this.worker.modifiedRecords)
            workCodesUpdate(codes)
        },

        // MARK: - Network
        async loadWorkCodes() {
            let hospitalID = this.hospital.selectedHospital._id
            let dateArray = this.worker.dateArray
            if (dateArray == undefined || dateArray.length == 0) {
                return
            }
            // let startDate = dateArray[0]
            // let lastDate = dateArray[dateArray.length - 1]
            let model = {
                hospitalID: hospitalID,
                isRemoved: false
                // removedAt: {
                //     $gte: moment(startDate).startOf('days').toString(),
                //     $lte: moment(lastDate).endOf('days').toString()
                // }
            }
            let workCodes
            try {
                workCodes = await this.queryClient.fetchQuery(v2WorkCodeFindQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }

            // 캐시 공유 배열을 직접 정렬하지 않도록 복사 후 정렬
            setWorkCodes([...workCodes].sort((l, r) => {
                return l.sortNum > r.sortNum ? 1 : -1
            }))
        }
    }
}
</script>
